import { capitalize } from "lodash";
import { BsFillInboxFill } from "react-icons/bs";

import { Section } from "../../types/types";

interface props {
  handleAcceptNoData?: () => void;
  section: Section;
}

const NoData: React.FC<props> = ({ section, handleAcceptNoData }) => (
  <div className="gm-no-data-container">
    <div className="gm-no-data-icon">
      <BsFillInboxFill size={60}/>
    </div>
    <div className="gm-no-data-text">No hay {section.plural || 'datos'} disponibles</div>
    {handleAcceptNoData &&
      <button className="gm-primary-button" type="button" onClick={handleAcceptNoData}>Crear {capitalize(section.singular || '')}</button>
    }
  </div>
);

export default NoData;